import { useCallback } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import { MonthTitle } from './MonthTitle.jsx';
import { MonthContent } from './MonthContent.jsx';
import { CreateDigestButton } from './CreateDigestButton.jsx';

const DateContainer = styled.div`
  padding: 16px 0;
  margin: 0 24px;
  width: calc(100% - 48px);
  max-width: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${props =>
    props.isCollapsed &&
    `border-bottom: 1px solid ${themeGet('colors.black.10')(props)};`}
`;

// When creating a new tile digest we want the following behaviour:
// 1. Current month minimum date is today, users should not be able to pick
//   past dates, e.g if today is Feb 15th then Feb 1-14th cannot be selected.
// 2. Any other month minimum date is the first day of the month.
const monthToInitialDate = month => {
  const today = moment();
  const parsedDate = moment(month, 'YYYY-MM');

  return (today.month() === parsedDate.month() &&
  today.year() === parsedDate.year()
    ? today
    : parsedDate
  ).format('DD-MM-YYYY');
};

export const MonthContainer = ({
  createNewTilesDigest,
  digestCount,
  isCollapsed,
  month,
  monthId,
  setIsCollapsed,
  tileDigests,
  tilesCount,
  year,
}) => {
  const initialDate = monthToInitialDate(month);
  const addTileDigest = useCallback(
    selectedDate => {
      createNewTilesDigest(selectedDate);
      setIsCollapsed(false);
    },
    [createNewTilesDigest, setIsCollapsed],
  );
  const toggleCollapsed = useCallback(() => {
    setIsCollapsed(!isCollapsed);
  }, [isCollapsed, setIsCollapsed]);

  return (
    <div>
      <DateContainer isCollapsed={isCollapsed} className="date-container">
        <MonthTitle
          toggleCollapsed={toggleCollapsed}
          tileDigests={tileDigests}
          isCollapsed={isCollapsed}
          tilesCount={tilesCount}
          digestCount={digestCount}
          monthId={monthId}
          year={year}
        />
        {!isCollapsed && createNewTilesDigest && digestCount > 0 && (
          <CreateDigestButton
            addTileDigest={addTileDigest}
            smallCalendar={true}
            initialDate={initialDate}
            marginCalendar={'0px 5px 0px 0px'}
            shouldBreak={false}
            textSize={'16px'}
          />
        )}
      </DateContainer>
      {!isCollapsed && (
        <MonthContent
          tileDigests={tileDigests}
          addTileDigest={addTileDigest}
          initialDate={initialDate}
          month={month}
        />
      )}
    </div>
  );
};
